import React from 'react'
import { css } from '@emotion/core'
import { LayoutBand, Skeleton, useContainerWidth, WhiteTheme } from '@fs/zion-ui'
import { emphasisBand } from './TryItOutShared.css'

const layoutBand = css`
  background-color: #006184;
  ${emphasisBand}
  display: flex;
  flex-direction: column;
`
const headerWrapper = css`
  padding: 1rem;
`

const footerWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const paragraph = css`
  color: white;
  text-align: center;
`

export default function TryItOutSkeleton() {
  const atWidth = useContainerWidth()
  const height = atWidth({
    default: '400px',
    sm: '400px',
    md: '450px',
    lg: '500px',
  })

  const imageViewerWrapper = css`
    align-items: center;
    border-top: 2px solid #ccc;
    display: flex;
    flex-direction: column;
    height: ${height};
    justify-content: center;
    margin-top: 6px;
    position: relative;
  `
  return (
    <LayoutBand css={layoutBand}>
      <div css={headerWrapper}>
        <WhiteTheme>
          <Skeleton.H1 subheadingLineCount={1} />
        </WhiteTheme>
      </div>
      <div css={imageViewerWrapper} />
      <div css={footerWrapper}>
        <p css={paragraph} />
      </div>
    </LayoutBand>
  )
}
